import { useState } from "react";
import { Mail, Loader2, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/apiClient";

export function NewsletterFooterForm() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/newsletter/subscribe", {
        email: email.trim(),
        // Default interest = ALL 3, since footer form has no checkbox
        interests: ["LOCATION", "ELECTRIQUE_IRVE", "DAO"],
        consent: true,
      });
      setDone(true);
      toast.success("Inscription confirmée !");
    } catch (err) {
      const msg = err?.response?.data?.detail || "Erreur d'inscription";
      toast.error(typeof msg === "string" ? msg : "Erreur d'inscription");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="footer-newsletter">
      <div className="text-white font-semibold mb-3">Newsletter</div>
      <p className="text-xs text-slate-400 mb-3 leading-relaxed">
        Recevez nos actualités matériel, IRVE et DAO.
      </p>
      {done ? (
        <div className="flex items-center gap-2 text-sm text-[#3DAE2B]" data-testid="footer-newsletter-success">
          <CheckCircle2 className="w-4 h-4" />
          Merci ! Inscription confirmée.
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-2">
          <div className="relative">
            <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="votre@email.com"
              data-testid="footer-newsletter-email"
              className="w-full h-10 pl-9 pr-3 rounded-full bg-white/5 border border-white/10 text-white text-sm placeholder-slate-500 focus:outline-none focus:border-[#FBBF24]"
            />
          </div>
          <button
            type="submit"
            disabled={busy}
            data-testid="footer-newsletter-submit"
            className="w-full h-10 rounded-full bg-[#FBBF24] hover:bg-[#F59E0B] text-[#0F172A] font-semibold text-xs inline-flex items-center justify-center gap-1.5 transition-colors disabled:opacity-60"
          >
            {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : null}
            {busy ? "…" : "S'inscrire"}
          </button>
          <p className="text-[10px] text-slate-500 leading-tight">
            Vous serez inscrit à tous nos sujets (Location, IRVE, DAO). En vous
            inscrivant, vous acceptez de recevoir nos communications.
            Désinscription à tout moment.
          </p>
        </form>
      )}
    </div>
  );
}

export default NewsletterFooterForm;
